import { render, staticRenderFns } from "./RsaSchedaAachenerAphasieTestDatiGeneraliEditComponent.vue?vue&type=template&id=2f56a492&scoped=true"
import script from "./RsaSchedaAachenerAphasieTestDatiGeneraliEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAachenerAphasieTestDatiGeneraliEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaSchedaAachenerAphasieTestDatiGeneraliEditComponent.vue?vue&type=style&index=0&id=2f56a492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f56a492",
  null
  
)

export default component.exports